import { render, staticRenderFns } from "./throbaxMain.vue?vue&type=template&id=75d63872&"
import script from "./throbaxMain.vue?vue&type=script&lang=js&"
export * from "./throbaxMain.vue?vue&type=script&lang=js&"
import style0 from "./throbaxMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports